import { render } from "./UpgradeOpportunities.vue?vue&type=template&id=58623644&scoped=true"
import script from "./UpgradeOpportunities.vue?vue&type=script&lang=js"
export * from "./UpgradeOpportunities.vue?vue&type=script&lang=js"

import "./UpgradeOpportunities.vue?vue&type=style&index=0&id=58623644&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58623644"]])

export default __exports__